<template>
  <main class="wrapper-content">
    <LmDataTableBuilder :isOnEditMode="isOnEditMode" :slug="slug" />
  </main>
</template>

<script>
import LmDataTableBuilder from '@/components/lmDataTable/builder'
export default {
  components: {
    LmDataTableBuilder
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    slug () {
      return this.$route?.params?.slug || null
    }
  }
}
</script>
